import React, { Component } from 'react';
import { StyleSheet, Image, View } from 'react-native';

import { PanoramaOutlined } from '@mui/icons-material';

const imageApi = `/thumbnails/{idImagem}`;

export default class ProductImage extends Component {
    state = {
        failed: false
    };

    render() {
        const { urlCdn, resizeMode, data } = this.props;
        const imageUrl = data.idImagem ? `${urlCdn}/thumbnails/${data.idImagem}` : ''

        let lsProdutoImagem = data.lsProdutoImagem || [];

        const [uriImage = []] = lsProdutoImagem;

        const { ds_thumbnail_url: dsThumbnailUrl = '' } = uriImage;

        if (this.state.failed || !dsThumbnailUrl) {
            return (
                <View style={[this.props.style, styles.imageAlign]}>
                    <PanoramaOutlined
                        sx={{
                            fontSize: resizeMode === 'center' ? 55 : 70
                        }}
                        style={styles.noImage}
                    />
                </View>
            );
        }

        return (
            <View>
                <Image
                    source={{ uri: dsThumbnailUrl || '' }}
                    style={this.props.style}
                    onError={this.onError.bind(this)}
                    resizeMode={'contain'}
                />
            </View>
        );
    }

    onError = () => {
        this.setState({ failed: true });
    };
}

const styles = StyleSheet.create({
    imageAlign: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    noImage: {
        color: '#ccc'
    }
});
